<template>
  <div class="address_big">
    <div style="width: 1260px; margin: 0 auto" v-if='type'>
      <div class="address_top">
        <div class="title">收货地址</div>
        <div class="address_text">
          <div class="left">
            <div v-if="add_show">
              <div class="boxx">
                <div class="boxx1">
                  <span style="letter-spacing: 4px">收货人：</span>
                  <el-input
                    style="width: 260px"
                    maxlength="20"
                    v-model="datas.consignee"
                  ></el-input>
                </div>
                <div class="boxx1">
                  <span>手机号码：</span>
                  <el-input
                    style="width: 260px"
                    maxlength="11"
                    @blur="bindphone"
                    v-model="datas.mobile"
                  ></el-input>
                </div>
              </div>
              <div class="boxx">
                <span>所在地区：</span>
                <div style="width: 653px">
                  <el-select
                    style="width: 152px; margin-right: 15px"
                    v-model="city_s"
                    @change="bindchanges"
                    placeholder="请选择省"
                  >
                    <el-option
                      v-for="item in dq_list"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                  <el-select
                    style="width: 152px; margin-right: 15px"
                    v-model="city_c"
                    @change="bindchangeq"
                    placeholder="请选择市"
                  >
                    <el-option
                      v-for="item in city_list"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                  <el-select
                    style="width: 152px; margin-right: 15px"
                    v-model="city_q"
                    @change="bindchangey"
                    placeholder="请选择区"
                  >
                    <el-option
                      v-for="item in qy_list"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                  <el-select
                    v-model="city_x"
                    v-if="xz_list.length > 0"
                    @change="bindchangex"
                    placeholder="请选择乡镇"
                    style="width: 152px; margin-right: 0"
                  >
                    <el-option
                      v-for="item in xz_list"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </div>
              </div>
              <div class="boxx11">
                <span>详细地址：</span>
                <el-input
                  type="textarea"
                  placeholder="请输入详细地址，如道路、门牌号、小区、楼栋号、单元等"
                  v-model="datas.detail"
                  maxlength="110"
                  style="width: 652px"
                ></el-input>
              </div>
            </div>
            <div v-else>
              <div style="margin-top: 30px">
                <span style="color: #909199; letter-spacing: 4px"
                  >收货人：</span
                >
                <span>{{ show_address.consignee }}</span>
                <span class="xiugai" @click="bindxiugai">修改</span>
              </div>
              <div style="margin: 20px 0">
                <span style="color: #909199">联系方式：</span>
                <span>{{ show_address.mobile }}</span>
              </div>
              <div>
                <span style="color: #909199">收货地址：</span>
                <span
                  >{{ show_address.province }}{{ show_address.city
                  }}{{ show_address.district }}{{ show_address.town
                  }}{{ show_address.detail }}</span
                >
              </div>
            </div>
          </div>
          <div class="right">
            <div v-if="add_show">
              <div style="margin-top: 50px; margin-bottom: 20px">
                <el-checkbox v-model="isDefault">设为默认</el-checkbox>
              </div>

              <div class="aniu">
                <span class="ljdh" @click="bc_address">地址确认</span>
                <span
                  v-if="address_list.length > 0"
                  class="ljdhs"
                  @click="bindqxqx"
                  >取消</span
                >
              </div>
            </div>
            <div v-else class="add_rights">
              <p
                class="new_adds"
                style="color: #3395f5"
                @click="tpVisible = true"
              >
                切换地址
              </p>
              <span class="new_add" @click="bindxj">新建地址</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- /////////////////////////////////////////////////////// -->
    <div style="margin: 0 auto;height:470px;" v-else>
      <div class="address_top address_tops" v-if='detail_type||address_list.length==0'>
        <div class="address_text">
          <div class="left">
            <!-- <div v-if="add_show"> -->
            <div>
              <div class="boxx">
                <div class="boxx1">
                  <span style="letter-spacing: 4px">收货人：</span>
                  <el-input
                    style="506px"
                    maxlength="12"
                    v-model="datas.consignee"
                  ></el-input>
                </div>
                
              </div>
              <div class="boxx1 boxx">
                  <span>手机号码：</span>
                  <el-input
                    style=""
                    maxlength="11"
                    @blur="bindphone"
                    v-model="datas.mobile"
                  ></el-input>
                </div>
              <div class="boxx">
                <span>所在地区：</span>
                <div style="width: 564px">
                  <el-select
                    style="width: 108px; margin-right: 15px"
                    v-model="city_s"
                    @change="bindchanges"
                    placeholder="请选择省"
                  >
                    <el-option
                      v-for="item in dq_list"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                  <el-select
                    style="width: 108px; margin-right: 15px"
                    v-model="city_c"
                    @change="bindchangeq"
                    placeholder="请选择市"
                  >
                    <el-option
                      v-for="item in city_list"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                  <el-select
                    style="width: 108px; margin-right: 15px"
                    v-model="city_q"
                    @change="bindchangey"
                    placeholder="请选择区"
                  >
                    <el-option
                      v-for="item in qy_list"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                  <el-select
                    v-model="city_x"
                    v-if="xz_list.length > 0"
                    @change="bindchangex"
                    placeholder="请选择乡镇"
                    style="width: 109px; margin-right: 0"
                  >
                    <el-option
                      v-for="item in xz_list"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </div>
              </div>
              <div class="boxx11 boxx">
                <span>详细地址：</span>
                <el-input
                  type="textarea"
                  placeholder="请输入详细地址，如道路、门牌号、小区、楼栋号、单元等"
                  v-model="datas.detail"
                  maxlength="200"
                  style="width: 563px"
                ></el-input>
              </div>
            </div>
          </div>
          
        </div>
        <div class="right" style="padding-left:90px;">
            <div>
              <div style="margin-top: 10px; margin-bottom: 20px">
                <el-checkbox v-model="isDefault">设为默认</el-checkbox>
              </div>

              
            </div>
            
          </div>
        <div class="aniu" style="padding:0 80px;margin-top:100px;display: flex;align-items: center;justify-content: space-around;">
            <span class="ljdh" @click="bc_address" style="display:inline-block;width: 144px;height: 42px;background: #F3A251;text-align:center;line-height:42px;color:white">地址确认</span>
            <span
                v-if="address_list.length > 0"
                class="ljdhs"
                style="display:inline-block;width: 144px;height: 42px;border: 1px solid #E8E8E8;text-align:center;line-height:42px;"
                @click="detail_type=false"
                >取消</span
        >
        </div>
      </div>
      <!-- ///// -->
      <div v-else >
          <el-button
          style="height：42px;width:144px;background:#F3A251;color:white;margin-bottom:10px;"
          @click="bindnew"
          >新建地址</el-button
        >
          <div
        style="
         height:350px;margin-bottom:20px;
          max-height: 500px;
          overflow: auto;
          
        "
      >
        <div
          @click="select_address(item.uid)"
          class="dz_box"
          :class="item.uid == add_index ? 'dz_top_active' : ''"
          v-for="item in address_list"
          :key="item.uid"
        >
          <div class="dz_top">
            <div>
              <span style="font-size: 16px; color: #0a1132">{{
                item.consignee
              }}</span>
              <span
                style="font-size: 16px; color: #0a1132; margin-left: 32px"
                >{{ item.mobile }}</span
              >
              <span
                style="
                  color: #3395f5;
                  border: 1px solid #3395f5;
                  margin-left: 10px;
                  display: inle-block;
                  padding: 0 5px;
                "
                v-if="item.defaultAddress"
                >默认</span
              >
            </div>
            <div>
                <span style="color: #5b5d66;margin-right:20px;" @click.stop="bindxiugais(item)"
              >修改</span
            >
            <span style="color: #5b5d66" @click.stop="binddelete(item.uid)"
              >删除</span
            >
            </div>
            
          </div>
          <p
            style="
              margin-top: 14px;
              color: #909199;
              width: 100%;
              text-align: left;
            "
          >
            {{ item.province }}{{ item.city }}{{ item.district }}{{ item.town
            }}{{ item.detail }}
          </p>
        </div>
      </div>
      <div slot="footer" class="dialog-footer" style="text-align: center">
        <el-button
          style="height：42px;width:144px;background:#F3A251;color:white;"
          @click="bindselects"
          >确定</el-button
        >
        <el-button style="height：42px;width:144px;"  @click="bindqqxs"
          >取消</el-button
        >
      </div>
      </div>
    </div>
    <!-- /////////////////////////////////////////////////////// -->
    <el-dialog
      title="选择收货地址"
      :visible.sync="tpVisible"
      width="620px"
      center
    >
      <div
        style="
          height: 350px;
          max-height: 550px;
          overflow: auto;
          padding: 0 20px;
        "
      >
        <div
          @click="select_address(item.uid)"
          class="dz_box"
          :class="item.uid == add_index ? 'dz_top_active' : ''"
          v-for="item in address_list"
          :key="item.uid"
        >
          <div class="dz_top">
            <div>
              <span style="font-size: 16px; color: #0a1132">{{
                item.consignee
              }}</span>
              <span
                style="font-size: 16px; color: #0a1132; margin-left: 32px"
                >{{ item.mobile }}</span
              >
              <span
                style="
                  color: #3395f5;
                  border: 1px solid #3395f5;
                  margin-left: 10px;
                  display: inle-block;
                  padding: 0 5px;
                "
                v-if="item.defaultAddress"
                >默认</span
              >
            </div>
            <span style="color: #5b5d66" @click.stop="binddelete(item.uid)"
              >删除</span
            >
          </div>
          <p
            style="
              margin-top: 14px;
              color: #909199;
              width: 100%;
              text-align: left;
            "
          >
            {{ item.province }}{{ item.city }}{{ item.district }}{{ item.town
            }}{{ item.detail }}
          </p>
        </div>
      </div>
      <div slot="footer" class="dialog-footer" style="text-align: center">
        <el-button
          style="height：42px;width:144px;background:#F3A251;color:white;"
          @click="bindselect"
          >确定</el-button
        >
        <el-button style="height：42px;width:144px;" @click="tpVisible = false"
          >取消</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import nav from "../views/nav";
import getCurrentCityName from "../js/map";
import links from "../js/link_parameters";
import wechatAuth from "../wechatAuth";
import { Message, Loading } from "element-ui";
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
import Vue from "vue";
import $ from "jquery";
import axios from "axios";
// import Tables from "../../tables/tables";
import echarts from "echarts";
import { formatDate, formatTimeToStr } from "../js/data";
export default {
  name: "index",
  components: {
    // Tables
  },
  props:{
        type:{
            type:Boolean,
            default:true
        },
       
        
    },
  data() {
    var vm = this;
    return {
      list: "",
      kj_number: "",
      k_number: "",
      k_password: "",
      add_k_show: false,
      detail_type: false,
      add_nav: 1,
      single: "",
      remark: "",
      c_time_list: [],
      qhjz_show: false,
      sjVisible: false,
      gift_list: "",
      datas: {},
      add_show: true,
      mr_checked: false,
      gift_details: "",
      tpVisible: false,
      cart_show: this.$route.query.cart_show
        ? this.$route.query.cart_show
        : false,
      address_list: "",
      show_address: "",
      add_index: null,
      loadingg: false,
      isDefault: false,
      loading: false,
      datas: {
        consignee: "",
        mobile: "",
        province: "",
        city: "",
        district: "",
        town: "",
        provinceId: "",
        cityId: "",
        districtId: "",
        townId: "",
        detail: "",
        isDefault: false,
      },
      dq_list: "", //地区
      city_s: "",
      city_list: "",
      city_c: "",
      qy_list: "",
      xz_list: "",
      city_q: "",
      city_x: "",
      province: {},
      city: {},
      district: {},
      town: {},
      zq_show: {}, //选中的专区
      address_show: true,
      ts_show: "",
      time_list: [],
      time_show: "",
      id_show: "",
      xz_show_time: "",
      user: "",
      all_price: 0,
      cart_list: [],
      card_list: [],
      freight: 0,
    };
  },
  computed: {},
  created() {},
  mounted() {
    var user = sessionStorage.getItem("user");
    if (user) {
      this.user = JSON.parse(user);
    } else {
      this.$router.push({ path: "/login" });
    }
    console.log(JSON.parse(user));
    this.getUser(true);
    this.getaddress(1);
    this.queryRegions();
    this.getOneMonthDateList();
  },
  methods: {
    bindnew(){
        this.detail_type=true
    },
    getUser(e) {
      var headers = {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: this.user.token,
      };
      this.$server.getCardUserBalance({}, headers).then((res) => {
        console.log(res);
        if (res.code == 0) {
          var user = this.user;
          this.$store.state.validTimes = res.data.default.validTimes;
          this.$store.state.balance = res.data.default.balance;
          sessionStorage.setItem("user", JSON.stringify(user));
          if (e) {
            res.data.default.show = true;
            this.card_list.push(res.data.default);
          }
        }
        console.log("卡list", this.card_list);
      });
    },
    bindadd() {
      console.log("添加");
    },
    bindnav(e) {
      this.add_nav = e;
    },
    bindxz_time(e) {
      this.time_show = e;
    },
    binddj_time(e) {
      if (e == "不支持配送") {
        return;
      }
      this.xz_show_time = this.time_show + " " + e;
    },

    getOneMonthDateList() {
      let daysInMonth = [0, 31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
      let currentDate = new Date();
      currentDate.setMonth(currentDate.getMonth() + 1);
      let strYear = currentDate.getFullYear();
      let strDay = currentDate.getDate();
      let strMonth = currentDate.getMonth() + 1;

      if ((strYear % 4 === 0) & (strYear % 100 !== 0) || strYear % 400 === 0) {
        daysInMonth[2] = 29;
      }

      if (strMonth - 1 === 0) {
        strYear -= 1;
        strMonth = 12;
      } else {
        strMonth -= 1;
      }

      strDay = Math.min(strDay, daysInMonth[strMonth]);

      if (strMonth < 10) {
        strMonth = "0" + strMonth;
      }

      if (strDay < 10) {
        strDay = "0" + strDay;
      }

      let dateStr = strYear + "-" + strMonth + "-" + strDay;
      const dateList = [];
      let startDate = new Date(dateStr);
      var ws = startDate.getDay();
      var weeks = ["周日", "周一", "周二", "周三", "周四", "周五", "周六"][ws];
      var jintian = {
        name: strMonth + "月" + strDay + "日 " + weeks,
        time: dateStr,
      };
      dateList.push(jintian);

      while (true) {
        startDate.setDate(startDate.getDate() + 1);
        var w = startDate.getDay();
        var week = ["周日", "周一", "周二", "周三", "周四", "周五", "周六"][w];
        if (startDate.getTime() < currentDate.getTime()) {
          var y = startDate.getMonth() + 1;
          var r = startDate.getMonth() - 1;
          var yy = y < 10 ? "0" + y : y;
          if (startDate.getDate() < 10) {
            // startDate.getFullYear() 获取年，此处没加上年份
            if (startDate.getMonth() < 10) {
              var time = {
                name: yy + "月0" + startDate.getDate() + "日 " + week,
                time:
                  startDate.getFullYear() +
                  "-0" +
                  y +
                  "-0" +
                  startDate.getDate(),
              };
            } else {
              var time = {
                name: yy + "月0" + startDate.getDate() + "日 " + week,
                time:
                  startDate.getFullYear() +
                  "-" +
                  y +
                  "-0" +
                  startDate.getDate(),
              };
            }

            dateList.push(time);
          } else {
            if (y < 10) {
              var time = {
                name: yy + "月" + startDate.getDate() + "日 " + week,
                time:
                  startDate.getFullYear() +
                  "-0" +
                  y +
                  "-" +
                  startDate.getDate(),
              };
            } else {
              var time = {
                name: yy + "月" + startDate.getDate() + "日 " + week,
                time:
                  startDate.getFullYear() + "-" + y + "-" + startDate.getDate(),
              };
            }

            dateList.push(time);
          }
        } else {
          break;
        }
      } // return dateList

      this.time_list = dateList;
      this.time_show = dateStr;
    },

    bindtime(e) {
      console.log(e);
      this.sjVisible = true;
      this.id_show = e.itemSkuJson.id;
    },
    bindphone(e) {
      var value = this.datas.mobile;
      console.log(this.datas.mobile);
      if (
        !/^[1](([3][0-9])|([4][0-9])|([5][0-9])|([6][0-9])|([7][0-9])|([8][0-9])|([9][0-9]))[0-9]{8}$/.test(
          value
        )
      ) {
        this.datas.mobile = "";
        this.$message({
          message: "请输入正确的手机号码",
          type: "warning",
        });
      }
    },
    // bindname(e){
    // 	console.log(e)
    // },
    bindqxqx() {
      this.add_show = false;
      this.city_s = "";
      this.city_c = "";
      this.city_q = "";
      this.bindcz();
    },
    binddelete(e) {
      this.$confirm("是否确认删除地址?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        var data = {
          addressUid: e,
        };
        var headers = {
          "Content-Type": "application/x-www-form-urlencoded",
          Authorization: this.user.token,
        };
        this.$server.deleteaddress(data, headers).then((res) => {
          console.log(res);
          if (res.code == 0) {
            this.$message({
              message: "删除成功",
              type: "sussecc",
            });
            if (e == this.show_address.uid) {
              this.add_index = null;
            }
            this.getaddress();
          } else {
            this.$message({
              message: res.msg,
              type: "warning",
            });
          }
        });
      });
    },
    bindxj() {
      this.bindcz();
      this.add_show = true;
    },
    bindxiugais(item){
      this.show_address = item
      this.detail_type = true
      this.bindxiugai()
    },
    bindxiugai() {
      console.log(this.show_address);
      this.bindcz();
      this.datas = this.show_address;
      this.datas.isDefault = this.show_address.defaultAddress;
      this.isDefault = this.show_address.defaultAddress;
      this.city_s = this.show_address.provinceId;
      this.city_c = this.show_address.cityId;
      this.city_q = this.show_address.districtId;
      this.city_x = this.show_address.townId;
      this.add_show = true;
      ///////////////////////////////////////////////////////////////
      var data = {
        parentId: this.show_address.provinceId,
      };
      var headers = {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: this.user.token,
      };
      this.$server.querydq(data, headers).then((res) => {
        console.log(res);
        var list = res.data.default;
        this.city_list = list;
        //						this.city_c= list[0]
      });
      var data = {
        parentId: this.show_address.cityId,
      };
      var headers = {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: this.user.token,
      };
      this.$server.querydq(data, headers).then((res) => {
        console.log(res);
        var list = res.data.default;
        this.qy_list = list;
        //						this.city_c= list[0]
      });
      var data = {
        parentId: this.show_address.districtId,
      };
      var headers = {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: this.user.token,
      };
      this.$server.querydq(data, headers).then((res) => {
        console.log(res);
        var list = res.data.default;
        this.xz_list = list;
        //						this.city_c= list[0]
      });
      //////////////////////////////////////////////////////////////////////
    },
    bc_address() {
//    console.log(this.city_s, this.city_c, this.city_q, this.city_x);
			if(this.user.festival&&this.user.festival.cardTestInfo){
				let infos = this.user.festival.cardTestInfo.split('_')
				if(this.user.cardNo==infos[0]){
					this.$confirm("当前登录为体验账号，仅作体验展示使用，暂不支持添加收货地址", "温馨提示", {
		        confirmButtonText: "确定",
		        cancelButtonText: "取消",
		        type: "warning",
		      }).then(() => {
		      	
		      })
					return
				}
			}
      if (!this.datas.consignee) {
        this.$message({
          message: "请输入姓名",
          type: "warning",
        });
        return;
      }
      if (!this.datas.mobile) {
        this.$message({
          message: "请输入手机号码",
          type: "warning",
        });
        return;
      }
      if (!this.city_c) {
        this.$message({
          message: "请选择所在地区",
          type: "warning",
        });
        return;
      }
      if (this.qy_list.length > 0 && !this.city_q) {
        this.$message({
          message: "请选择所在区",
          type: "warning",
        });
        return;
      }
      if (this.xz_list.length > 0 && !this.city_x) {
        this.$message({
          message: "请选择所在乡镇",
          type: "warning",
        });
        return;
      }
      if (!this.datas.detail) {
        this.$message({
          message: "请输入详细地址",
          type: "warning",
        });
        return;
      }
      this.datas.provinceId = this.city_s;
      this.dq_list.forEach((item) => {
        if (item.id == this.city_s) {
          console.log(item);
          this.datas.province = item.name;
        }
      });
      this.datas.cityId = this.city_c;
      this.city_list.forEach((item) => {
        if (item.id == this.city_c) {
          this.datas.city = item.name;
        }
      });
      this.datas.districtId = this.city_q;
      this.qy_list.forEach((item) => {
        if (item.id == this.city_q) {
          this.datas.district = item.name;
        }
      });
      this.datas.townId = this.city_x ? this.city_x : 0;
      this.xz_list.forEach((item) => {
        if (item.id == this.city_x) {
          this.datas.town = item.name;
        }
      });
      console.log(this.datas);
      var headers = {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: this.user.token,
      };
      this.datas.isDefault = this.isDefault;
      if (this.datas.uid) {
        this.datas.addressUid = this.datas.uid;
        this.$server.updateaddress(this.datas, headers).then((res) => {
          console.log(res);
          if (res.code == 0) {
            this.$message({
              message: "修改成功",
              type: "success",
            });
            this.show_address = res.data.default;
            this.add_index = res.data.default.uid;
            this.add_show = false;
            this.getaddress();
            this.city_list = [];
            this.qy_list = [];
            this.xz_list = [];
            this.city_s = "";
            this.city_c = "";
            this.city_q = "";
            this.detail_type=false
            this.bindcz();
          } else {
            this.$message({
              message: res.msg,
              type: "error",
            });
          }
        });
      } else {
        this.$server.createaddress(this.datas, headers).then((res) => {
          console.log(res);
          if (res.code == 0) {
            this.$message({
              message: "新建成功",
              type: "success",
            });
            this.show_address = res.data.default;
            this.add_index = res.data.default.uid;
            this.add_show = false;
            this.detail_type=false
            this.getaddress();
            this.city_s = "";
            this.city_c = "";
            this.city_q = "";
            this.bindcz();
          } else {
            this.$message({
              message: res.msg,
              type: "error",
            });
          }
        });
      }
    },
    bindcz() {
      this.city_list = [];
      this.qy_list = [];
      this.xz_list = [];
      this.city_s = "";
      this.isDefault = false;
      this.datas = {
        consignee: "",
        mobile: "",
        province: "",
        city: "",
        district: "",
        town: "",
        provinceId: "",
        cityId: "",
        districtId: "",
        townId: "",
        detail: "",
        // isDefault:false
      };
      //   this.$emit('bindselect',this.show_address)
    },
    //////
    queryRegions() {
      //查询地区
      var data = {
        parentId: "0",
      };
      var headers = {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: this.user.token,
      };
      this.$server.querydq(data, headers).then((res) => {
        console.log(res);
        if (res.code == 0) {
          var list = res.data.default;
          console.log("地区", list);
          this.dq_list = list;
        } else {
          //							this.$Message.error(res.msg)
        }
      });
    },
    bindchangey(e) {
      console.log(e);
      this.city_x = "";
      this.xz_list = "";
      this.qy_list.forEach((item) => {
        if (item.id == e) {
          this.district = item;
        }
      });
      var data = {
        parentId: e,
      };
      var headers = {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: this.user.token,
      };
      this.$server.querydq(data, headers).then((res) => {
        console.log(res);
        var list = res.data.default;
        this.xz_list = list;
        //						this.city_c= list[0]
      });
    },
    bindchangex(e) {
      console.log(e);
      this.xz_list.forEach((item) => {
        if (item.id == e) {
          this.town = item;
        }
      });
    },
    bindchangeq(e) {
      this.city_q = "";
      this.city_x = "";
      //				this.qy_list=''
      this.xz_list = "";
      console.log(e);
      this.city_list.forEach((item) => {
        if (item.id == e) {
          this.city = item;
        }
      });
      var data = {
        parentId: e,
      };
      var headers = {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: this.user.token,
      };
      this.$server.querydq(data, headers).then((res) => {
        console.log(res);
        var list = res.data.default;
        this.qy_list = list;
        //						this.city_c= list[0]
        // this.bindchangey(this.city_q)
      });
    },
    bindchanges(e) {
      this.city_c = "";
      this.city_q = "";
      this.city_x = "";
      this.city_list = "";
      this.qy_list = "";
      this.xz_list = "";
      console.log(e);
      this.dq_list.forEach((item) => {
        if (item.id == e) {
          this.province = item;
        }
      });
      var data = {
        parentId: e,
      };
      var headers = {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: this.user.token,
      };
      this.$server.querydq(data, headers).then((res) => {
        console.log(res);
        var list = res.data.default;
        this.city_list = list;
        //						this.city_c= list[0]
      });
    },
    /////
    bindqqxs(){
        this.tpVisible = false;
        this.$emit('bindqqxs')
    },
     bindselects() {
      this.address_list.forEach((item) => {
        if (item.uid == this.add_index) {
          this.show_address = item;
        //   this.getaddress();
        }
      });
    //   this.tpVisible = false;
        this.$emit('bindselects',this.show_address)
    },
    bindselect() {
      this.address_list.forEach((item) => {
        if (item.uid == this.add_index) {
          this.show_address = item;
          this.getaddress();
        }
      });
      this.tpVisible = false;
      //   this.$emit('bindselect',this.show_address)
    },
    select_address(e) {
      this.add_index = e;
      // this.qr_address();
    },
    bindduihuang() {
      this.$router.push({ path: "/result" });
    },
    getaddress(type) {
        var show_address = localStorage.getItem("show_address");
      var headers = {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: this.user.token,
      };
      this.$server.queryaddress({}, headers).then((res) => {
        if (res.code == 0) {
          console.log("dizhi", res);
          var list = res.data.default;
          this.address_list = list;
          if (this.add_index == null) {
            this.show_address = list[0];
            this.add_index = list[0] ? list[0].uid : "";
          }

          list.forEach((item, index) => {
            if (item.defaultAddress) {
              if (this.add_index == null) {
                this.show_address = item;
                this.add_index = item.uid;
              }
            }
          });
        if(type==1&&show_address&&list.length>0){
            console.log('1111111111111111111111111')
            this.show_address = show_address?JSON.parse(show_address):'';
            this.add_index = show_address?JSON.parse(show_address).uid:'';
          }
          if (list.length > 0) {
            this.add_show = false;
          } else {
            this.add_show = true;
            this.tpVisible = false;
          }
          if (this.cart_show == true) {
          } else {
          }
          localStorage.setItem("show_address",JSON.stringify(this.show_address));
          this.$emit("bindselect", this.show_address);
        }
      });
    },
  },
  computed: {},
};
</script>

<style lang="scss" scoped>
.address_tops{
    width:600px!important;
    border:none!important;
}
.address_tops .address_text{
    padding:0!important;
}
.address_tops .address_text .left{
    width:95%!important;
}
.address_tops .address_text .left .boxx span{
    display: inline-block;
    width:105px!important;
}
.address_tops .address_text .left .boxx1 span{
    display: inline-block;
    width:105px!important;
}
.address_tops .address_text .left .boxx1{
    width:100%!important;
}
.tk_box {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  .add_kj {
    width: 420px;
    height: 320px;
    background: white;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    .ggbb {
      width: 30px;
      height: 30px;
      position: absolute;
      top: 5px;
      right: 5px;
    }
    .add_kj_center1 {
      overflow-y: auto;
      height: 160px;
      padding: 0 32px;
      margin-top: 10px;
      .ybk_box {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 16px;
        span {
          font-size: 16px;
          color: #333333;
        }
        div {
          i {
            display: inline-block;
            width: 16px;
            height: 16px;
            border-radius: 50%;
            border: 1px solid #e6e6e6;
          }
        }
      }
    }
    .kj_bottom {
      width: 100%;
      position: absolute;
      box-sizing: border-box;
      background: white;
      // bottom:0;
      display: flex;
      justify-content: space-around;
      align-items: center;
      height: 52px;
      span {
        font-size: 12px;
        cursor: pointer;
        width: 72px;
        height: 32px;
        display: inline-block;
        border: 1px solid #e8e8e8;
        line-height: 32px;
        text-align: center;
      }
      span:nth-child(1) {
        background: #f3a251;
        color: white;
        margin-left: 15px;
        margin-right: 16px;
      }
    }
    .add_kj_center {
      .center_box {
        margin-bottom: 16px;
        input {
          height: 32px;
          padding: 0 16px;
          width: 240px;
          margin-left: 16px;
          outline: none;
          border: 1px solid #e6e6e6;
        }
      }
    }
    .add_kj_nav {
      width: 270px;
      height: 32px;
      margin: 24px auto;
      .add_nav_active {
        background: #fff4eb !important;
        border-color: #fac593;
        color: #ee8f36;
      }
      span {
        display: inline-block;
        height: 32px;
        line-height: 32px;
        cursor: pointer;
        width: 90px;
        border: 1px solid #e6e6e6;
      }
    }
    .add_kj_top {
      height: 40px;
      padding: 0 16px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      background: #e6e6e6;
      img {
        height: 20px;
        width: 20px;
        cursor: pointer;
      }
    }
  }
  .bj {
    height: 100%;
    width: 100%;
    background: #000000;
    opacity: 0.5;
  }
}
.tk_box {
  text-align: center;
  #qrCode {
    width: 49%;
    text-align: center;
    margin: 20px auto;
  }
  .an {
    margin-top: 20px;
    display: flex;
    justify-content: space-around;
    span {
      display: inline-block;
      height: 30px;
      width: 90px;
      text-align: center;
      line-height: 32px;
      cursor: pointer;
      border: 1px solid white;
      border-radius: 50px;
      font-size: 12px;
    }
    span:nth-child(1) {
      border: 1px solid #e6e6e6;
      background: white;
      margin-right: 24px;
    }
    span:nth-child(2) {
      margin-left: 5px;
      border-color: #f14a61;
      background: white;
      color: #f14a61;
    }
  }
}
.k_boxs {
  border: 1px solid #f3a251 !important;
  background: #fff7f0;
}
.k_boxs .k_num {
  color: #f3a251 !important;
}
.k_boxs .k_bl {
  border-color: #f3a251;
}

.box_x {
  display: flex;
  align-items: center;
  margin-left: 24px;
  margin-bottom: 24px;
  cursor: pointer;
}
.add_k {
  width: 100px;
  height: 32px;
  border: 1px solid #e6e6e6;
  display: flex;
  padding: 0 10px;
  align-items: center;
  margin-right: 24px;
  justify-content: space-around;
}
.k_big {
  display: flex;
  min-height: 170px !important;
  align-items: center;
  flex-wrap: wrap;
  padding: 24px !important;
  padding-bottom: 0 !important;
}
.k_box {
  display: flex;
  align-items: center;
  padding: 10px;
  margin-right: 24px;
  margin-bottom: 24px;
}
.k_box:nth-child(4n + 4) {
  margin-right: 0;
}
.k_bl {
  display: flex;
  padding: 10px 0;
  margin-bottom: 14px;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #e6e6e6;
}
.t_active {
  color: #f3a251;
  border: 1px solid #f3a251 !important;
}
.xzrq {
  display: flex;
}
.sj_box {
  display: inline-block;
  padding: 2px 5px;
  border: 1px solid #e6e6e6;
  margin-right: 10px;
  margin-bottom: 10px;
  cursor: pointer;
}
.binddh {
  opacity: 0.6;
}
.xiugai {
  height: 24px;
  width: 60px;
  text-align: center;
  line-height: 24px;
  border: 1px solid #f3a251;
  color: #f3a251;
  display: inline-block;
  cursor: pointer;
  margin-left: 20px;
}
.dz_top_active {
  border-color: #f3a251 !important;
  background: url("../assets/img/dz_xz.png") no-repeat right bottom;
}
.dz_box {
  min-height: 87px;
  cursor: pointer;

  border: 1px solid #e6e6e6;
  padding: 14px 16px;
  margin-bottom: 16px;
  .dz_top {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
}
.add_rights {
  padding-left: 12px;
  display: flex;
  flex-direction: column;
}
.new_adds {
  width: 144px;
  height: 42px;
  display: inline-block;
  text-align: center;
  line-height: 42px;
  cursor: pointer;
}
.new_add {
  width: 144px;
  height: 42px;
  border: 1px solid rgba(232, 232, 232, 1);
  display: inline-block;
  text-align: center;
  line-height: 42px;
  cursor: pointer;
}
.address_bottom {
  margin-top: 30px;
}
.lists {
  min-height: 50px;
  border: 1px solid #e6e6e6;
  .rights {
    width: 200px;
    text-align: center;
  }
  .list_bottom {
    padding: 0 24px;
    min-height: 200px;
    .l_boxs:last-child {
      .l_box:last-child {
        border: none;
      }
    }

    .l_box {
      display: flex;
      align-items: center;
      padding: 24px 0;
      border-bottom: 1px dotted #cccccc;
    }
  }
  .list_top {
    display: flex;
    color: #909199;
    background: #f5f5f5;
    height: 44px;
    line-height: 44px;
    padding-left: 24px;
  }
}
.select {
  width: 145px;
  height: 32px;
  margin-right: 24px;
}
.address_text {
  //   height: 247px;
  width: 100%;
  padding: 20px 32px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .right {
    width: 421px;
    height: 100%;
    border-left: 1px dotted #cccccc;
    padding-left: 32px;
    .aniu {
      display: flex;
      align-items: center;
    }
    .ljdhs {
      height: 50px;
      width: 186px;
      display: inline-block;
      line-height: 50px;
      margin-left: 10px;
      cursor: pointer;
      text-align: center;
      color: #f3a251;
      border: 1px solid;
      background: #fffaf6;
    }
    .ljdh {
      height: 50px;
      cursor: pointer;
      width: 186px;
      background: #f3a251;
      display: inline-block;
      line-height: 50px;
      text-align: center;
      color: white;
    }
  }
  .left {
    height: 100%;
    width: 738px;
    .boxx11 {
      display: flex;
      justify-content: space-between;
    }
    .boxx {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 24px;
      .boxx1 {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 47%;
      }
    }
  }
}
.address_top {
  border: 1px solid #e6e6e6;
  margin-top: 32px;
  //   height: 291px;
  width: 100%;
  .title {
    height: 44px;
    width: 100%;
    background: #f5f5f5;
    color: #909199;
    font-size: 16px;
    line-height: 44px;
    padding-left: 22px;
  }
}
.address_bigs {
  //   min-height: 87vh;
  border-top: 1px solid #e4e5ed;
  padding-bottom: 50px;
}
</style>